import { createSelector } from 'reselect'

const adminOnboardingSelector = state => state.adminOnboarding

export default createSelector(
	[adminOnboardingSelector],
	adminOnboarding => ({
		isTrialFromSF: adminOnboarding.isTrialFromSF,
	})
)
